import React, { useState, useContext } from 'react';
import { Paper, TextInput, PasswordInput, Button, Title, Group } from '@mantine/core';
import { motion } from 'framer-motion';
import { FaLock, FaKey } from 'react-icons/fa';
import { toast } from 'react-toastify';
import {changePassword} from '../../axios';
import authContext from '../../AuthContext';

const ChangePasswordForm = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const { user } = useContext(authContext);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    try {
      const response = await changePassword(user,password);
      toast.success('Password changed successfully');
      //console.log(response.data);
      setPassword('');
      setConfirmPassword('');
    } catch (error) {
      console.error(error);
      toast.error('Error changing password');
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Paper
        radius="md"
        p="xl"
        withBorder
        shadow="md"
        style={{ maxWidth: 500, margin: 'auto', marginTop: '4rem' }}
      >
        <Group position="center" mb="md">
          <FaLock size={24} style={{ color: '#2c7a3b' }}/>
          <Title order={3} style={{ color: '#2c7a3b' }}>Change Password</Title>
        </Group>

        <form onSubmit={handleSubmit}>
          <PasswordInput
            label="New Password"
            placeholder="Enter new password"
            icon={<FaKey />}
            value={password}
            onChange={(e) => setPassword(e.currentTarget.value)}
            required
            mb="md"
          />

          <PasswordInput
            label="Confirm Password"
            placeholder="Re-enter new password"
            icon={<FaKey />}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.currentTarget.value)}
            required
            mb="lg"
          />

          <Button fullWidth type="submit" style={{ backgroundColor: '#2c7a3b',color:'white' }} radius="md">
            Update Password
          </Button>
        </form>
      </Paper>
    </motion.div>
  );
};

export default ChangePasswordForm;
